var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import ViewerErrorBoundary from '../common/ViewerConclusion/ViewerErrorBoundary';
import { LinkLauncher } from './Launcher';
import { LinkMetadata } from './Metadata';
import { LinkType } from './types';
export const LinkViewer = (_a) => {
    var { componentValues, onClick, children } = _a, others = __rest(_a, ["componentValues", "onClick", "children"]);
    if (componentValues.linkType === LinkType.EXAM || componentValues.linkType === LinkType.LAB) {
        return (React.createElement(ViewerErrorBoundary, null,
            React.createElement(LinkLauncher, Object.assign({}, others, { link: componentValues, onClick: onClick }))));
    }
    if (componentValues.linkType === LinkType.META) {
        return (React.createElement(ViewerErrorBoundary, null,
            React.createElement(LinkMetadata, Object.assign({}, others, { link: componentValues, onClick: onClick }))));
    }
    return (React.createElement(ViewerErrorBoundary, null,
        React.createElement("a", { href: componentValues === null || componentValues === void 0 ? void 0 : componentValues.url, target: "_blank", rel: "noreferrer" }, children)));
};
export default LinkViewer;
//# sourceMappingURL=index.js.map